export const GET_RRHH_REQUEST = 'GET_RRHH_REQUEST';
export const GET_RRHH_SUCCESS = 'GET_RRHH_SUCCESS';
export const GET_RRHH_FAILURE = 'GET_RRHH_FAILURE';
export const RESET_RRHH = 'RESET_RRHH';
